var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.8337C14.6023 18.8337 18.3333 15.1027 18.3333 10.5003C18.3333 5.89795 14.6023 2.16699 9.99996 2.16699C5.39759 2.16699 1.66663 5.89795 1.66663 10.5003C1.66663 15.1027 5.39759 18.8337 9.99996 18.8337Z",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.8337C5.40274 18.8337 1.66663 15.0975 1.66663 10.5003C1.66663 5.9031 5.40274 2.16699 9.99996 2.16699C10.0833 5.86144 10.0833 8.06977 9.99996 18.8337Z",
    fill: "#9DA1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemes);
export default __webpack_public_path__ + "static/media/Themes.4b004850ffe04e5e48452643aeb25442.svg";
export { ForwardRef as ReactComponent };